import * as moment from 'vendors/moment-locale-th';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MdDialog } from '@angular/material';
import $ from 'jquery';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { Router } from '@angular/router';
import { SearchFormModel } from 'app/model/search-form-model';
import { SearchService } from 'app/services/search/search.service';
import { UtilitiesService } from 'app/services/utilities/utilities.service';

@Component({
  selector: 'app-promotion-search-box',
  templateUrl: './promotion-search-box.component.html',
  styleUrls: ['./promotion-search-box.component.scss']
})
export class PromotionSearchBoxComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Input() type: string = 'H'; // H = home, C = Level-C, D = Level-D
  @Input() layout: string = 'home'; // home, topwrap
  @Output('onSubmitSearch') submitSearch = new EventEmitter(); // tslint:disable-line:no-output-rename
  @Output('onGetData') sendData = new EventEmitter(); // tslint:disable-line:no-output-rename
  @Output('onGetState') sendState = new EventEmitter(); // tslint:disable-line:no-output-rename

  @ViewChild('inputDestination') inputDestination;
  @ViewChild('inputCheckIn') inputCheckIn;
  @ViewChild('inputRoomBox') inputRoomBox;

  public searchForm: FormGroup;
  public searchFormModel: SearchFormModel = new SearchFormModel();
  public lastestSearchForm: any;
  public stateDaterangepicker: any;
  public titleDestination: string;
  public searchSubmitted: boolean = false;
  public dateCheckInOutput: string;
  public dateCheckOutOutput: string;

  public user: any;
  public isLimitChild: boolean;
  public isLimitRoom: boolean;
  public isShowRoomBox: boolean = false;
  public isRoomBoxShowArrow: boolean = false;
  public isWorkOnly: boolean = false;
  public isEditable: boolean = false;

  public roomCount: number = 1;
  public adultCount: number = 2;
  public childCount: number = 0;
  public currentTabRoom: number = 1;
  public currentRoom: any;

  constructor(
    private formBuilder: FormBuilder,
    private searchService: SearchService,
    private appConfigService: AppConfigService,
    private router: Router,
    public dialog: MdDialog,
    public utilitiesService: UtilitiesService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.data.firstChange && changes && changes.data && changes.data.currentValue && changes.data.currentValue.guests.length !== this.searchFormModel.guests.length) {
      this.searchFormModel.guests = this.data.guests;
      this.searchForm.get('guests').setValue(this.searchFormModel.guests);
      this.currentRoom = this.searchForm.value.guests[0];
      this.lastestSearchForm = JSON.parse(JSON.stringify(this.searchForm.value));
      this.updateCountOfRoom();
      this.onSubmit({value: this.searchFormModel, valid: true});
    }
  }

  ngOnInit() {
    if (!this.data) {
      this.data = {
        checkInDate: moment().format('DD-MM-YYYY'),
        checkOutDate: moment().add(1, 'days').format('DD-MM-YYYY'),
        destination: { title: '', id: '', suggestCat: '', slug: '' },
        guests: [{ adult: 2, children: [] }],
        purpose: 'leisure'
      }
    }

    // Setup Data
    this.searchFormModel.destination = this.data.destination;
    this.searchFormModel.guests = this.data.guests;
    this.searchFormModel.checkInDate = this.utilitiesService.reverseFormatDate(this.data.checkInDate);
    this.searchFormModel.checkOutDate = this.utilitiesService.reverseFormatDate(this.data.checkOutDate);
    this.searchFormModel.purpose = this.data.purpose;

    this.searchForm = this.formBuilder.group({
      'destination': this.formBuilder.group({
        id: [this.searchFormModel.destination.id],
        title: [this.searchFormModel.destination.title, Validators.required],
        suggestCat: [this.searchFormModel.destination.suggestCat],
        slug: [this.searchFormModel.destination.slug],
        poi: [this.searchFormModel.destination.poi],
      }),
      'checkInDate': [this.searchFormModel.checkInDate, Validators.required],
      'checkOutDate': [this.searchFormModel.checkOutDate, Validators.required],
      'guests': [this.searchFormModel.guests, Validators.required],
    });

    this.currentRoom = this.searchForm.value.guests[0];
    this.lastestSearchForm = JSON.parse(JSON.stringify(this.searchForm.value));
    this.updateCountOfRoom();
    // call emit data when outside component need data
    this.sendData.emit({ data: this.lastestSearchForm });

    // init date on text read
    this.dateCheckInOutput = this.utilitiesService.getOtaFormatYear(this.lang(), this.searchForm.value.checkInDate);
    this.dateCheckOutOutput = this.utilitiesService.getOtaFormatYear(this.lang(), this.searchForm.value.checkOutDate);

    this.searchForm.controls.checkInDate.valueChanges.subscribe((val) => { // YYYY-MM-DD
      this.dateCheckInOutput = this.utilitiesService.getOtaFormatYear(this.lang(), val);
    });

    this.searchForm.controls.checkOutDate.valueChanges.subscribe((val) => { // YYYY-MM-DD
      this.dateCheckOutOutput = this.utilitiesService.getOtaFormatYear(this.lang(), val);
    });

    this.appConfigService.getLanguageObs().subscribe(lang => {
      this.dateCheckInOutput = this.utilitiesService.getOtaFormatYear(lang, this.searchForm.value.checkInDate);
      this.dateCheckOutOutput = this.utilitiesService.getOtaFormatYear(lang, this.searchForm.value.checkOutDate);
    });

    // init class header for can know type search-box from css context
    let $html = $('html');
    $html.removeClass('topwrap-layout home-layout');
    $html.addClass(this.layout + '-layout');
  }

  onSubmit({ value, valid }: { value: SearchFormModel, valid: boolean }) {

    this.searchSubmitted = true;

    let suggestCat = this.searchForm.value.destination.suggestCat;
    let slug = suggestCat === 'pointofinterest' ? '' : this.searchForm.value.destination.slug;

    slug = this.utilitiesService.resolveSlugSpace(slug);

    if (suggestCat == 'product' || suggestCat == 'hotel') {
      this.data = {
        destination: this.utilitiesService.base64Encoder(JSON.stringify(this.searchFormModel.destination)),
        purpose: this.searchFormModel.purpose,
        checkIn: this.utilitiesService.reverseFormatDate(this.searchForm.value.checkInDate),
        checkOut: this.utilitiesService.reverseFormatDate(this.searchForm.value.checkOutDate),
        guests: this.utilitiesService.base64Encoder(JSON.stringify(this.searchForm.value.guests)),
        lang: this.lang()
      }
      this.submitSearch.emit({ data: this.data });
      this.hideEditable();
    }
  }

  lang() {
    return this.appConfigService.getLanguage();
  }

  isShowLimitedRoomSelect() {
    return this.searchForm.value.purpose == 'work' && this.isLimitRoom;
  }

  isShowFreeStyleRoomSelect() {
    return (this.searchForm.value.purpose == 'leisure' || !this.isLimitRoom) && this.searchForm.value.purpose != '';
  }

  toggleRoomBox(event: any) {
    if (this.isShowRoomBox) {
      this.hideRoomBox(event);
    } else {
      this.showRoomBox(event);
    }
  }

  showRoomBox(event: any) {
    this.isShowRoomBox = true;

    // Oganize JS Queue Stack Process.
    setTimeout(() => {
      $('html').on('click.hideRoomBox', (e) => {
        this.hideRoomBox(e);
      });
      this.detectToShowArrow();
    });
  }

  hideRoomBox(event: any) {
    this.isShowRoomBox = false;
    $('html').off('click.hideRoomBox');
  }

  stopPropagation(event: any) {
    event.stopPropagation();
  }

  resetToRoomDefault() {
    this.setActiveTabRoom(1);
    this.searchForm.controls.guests.setValue([{ adult: 2, children: [] }]);
    this.currentRoom = this.searchForm.value.guests[0];
    this.roomCount = 1;
    this.adultCount = 2;
  }

  // RoomBox
  handlerOnChangeRoom(event: any) {
    let oldRoomCount = this.roomCount;
    let roomChoose = parseInt(event.target.value);
    let _rooms = this.searchForm.value.guests;

    if (oldRoomCount > roomChoose) {
      // delete room
      _rooms.splice(roomChoose);
      this.setActiveTabRoom(roomChoose);
    } else {
      // add room
      let newRoomsCount = roomChoose - oldRoomCount;
      let newRooms = [];
      for (let i = 0; i < newRoomsCount; i++) {
        newRooms.push({
          adult: 2,
          children: []
        });
      }

      this.searchForm.controls.guests.setValue(_rooms.concat(newRooms));
    }
    this.roomCount = roomChoose;
    this.updateCountOfRoom();
    this.detectToShowArrow();
  }

  handlerOnChangeAdultCount(event: any) {
    let _adultCount = parseInt(event.target.value);
    this.currentRoom.adult = _adultCount;
    this.updateCountOfRoom();
  }

  handlerOnChangeChildren(event: any) {
    let oldChildrenCount = this.currentRoom.children.length;
    let _childrenCount = parseInt(event.target.value);

    if (oldChildrenCount > _childrenCount) {
      // delete children
      this.currentRoom.children.splice(_childrenCount);
    } else {
      // add children
      let newChildrenCount = _childrenCount - oldChildrenCount;
      let newChildren = [];
      for (let i = 0; i < newChildrenCount; i++) {
        newChildren.push(1);
      }
      this.currentRoom.children = this.currentRoom.children.concat(newChildren);
    }
    this.updateCountOfRoom();
  }

  handlerOnChangeChildrenOld(event: any, i) {
    this.currentRoom.children[i] = parseInt(event.target.value);
  }

  resetChildren() {
    let _rooms = this.searchForm.value.guests;
    _rooms.forEach((room) => {
      room.children = [];
    });
    this.childCount = 0;
    this.searchForm.controls.guests.setValue(_rooms);
  }

  setActiveTabRoom(index) {
    if (this.currentTabRoom != index) {
      this.currentTabRoom = index;
      this.currentRoom = this.searchForm.value.guests[index - 1];
      this.moveScrollToItem();
    }
  }

  nextActiveTabRoom() {
    let nextRoom = this.currentTabRoom < this.searchForm.value.guests.length ? this.currentTabRoom + 1 : this.currentTabRoom;
    this.setActiveTabRoom(nextRoom);
    this.moveScrollToItem();
  }

  prevActiveTabRoom() {
    let prevRoom = this.currentTabRoom > 1 ? this.currentTabRoom - 1 : 1;
    this.setActiveTabRoom(prevRoom);
    this.moveScrollToItem();
  }

  detectToShowArrow() {
    let $tabContainer = $('.select-room-popup-container');
    let $scrollContainer = $tabContainer.find('.tab-detail-room-list ul');
    let $tabs = $tabContainer.find('li');
    let $currentTab = $tabs[this.currentTabRoom - 1];

    let tabWidth = $currentTab.clientWidth;
    let scrollContainerWidth = $scrollContainer[0].clientWidth;
    let scrollLeft = $scrollContainer[0].scrollLeft;
    let currentPosLeft = $($currentTab).position().left;
    let currentPosRight = currentPosLeft + tabWidth;

    // detect item is width over range
    if ((tabWidth + 2) * this.roomCount > scrollContainerWidth) {
      this.isRoomBoxShowArrow = true;
    } else {
      this.isRoomBoxShowArrow = false;
    }
  }

  moveScrollToItem() {
    let $tabContainer = $('.select-room-popup-container');
    let $scrollContainer = $tabContainer.find('.tab-detail-room-list ul');
    let $tabs = $tabContainer.find('li');
    let $currentTab = $tabs[this.currentTabRoom - 1];

    let tabWidth = $currentTab.clientWidth;
    let scrollContainerWidth = $scrollContainer[0].clientWidth;
    let scrollLeft = $scrollContainer[0].scrollLeft;
    let currentPosLeft = $($currentTab).position().left;
    let currentPosRight = currentPosLeft + tabWidth;

    // detect visible tab on scroll
    let targetLeftPos = (tabWidth + 2) * (this.currentTabRoom - 1);
    if (currentPosRight > scrollContainerWidth) {
      $scrollContainer[0].scrollLeft = targetLeftPos - scrollContainerWidth + tabWidth + 30;
    } else if (currentPosLeft < 0) {
      $scrollContainer[0].scrollLeft = targetLeftPos - 30;
    }
  }

  updateCountOfRoom() {
    let _adultCount = 0;
    let _childCount = 0;
    this.searchForm.value.guests.forEach((room, i) => {
      _adultCount += room.adult;
      _childCount += room.children.length;
    });
    this.roomCount = this.searchForm.value.guests.length;
    this.adultCount = _adultCount;
    this.childCount = _childCount;
  }

  trackByChild(index: number, child): number {
    return index;
  }

  // top wrap layout
  showEditable() {
    this.isEditable = true;
    this.sendState.emit({ mode: 'EDIT' });
  }
  hideEditable() {
    this.isEditable = false;
    this.sendState.emit({ mode: 'NORMAL' });
  }
  cancleChangeSearch() {
    this.hideEditable();
    this.searchForm.reset(JSON.parse(JSON.stringify(this.lastestSearchForm)));
    //this.isSelectedDestination = true;
    this.currentRoom = this.searchForm.value.guests[0];
    this.updateCountOfRoom();
  }

  handleClickDestinationTextArea() {
    this.showEditable();
    if (!window.matchMedia('(max-width: 767px)').matches) {
      setTimeout(() => {
        this.inputCheckIn.nativeElement.focus();
      }, 600);
    } else {
      setTimeout(() => {
        this.inputCheckIn.nativeElement.focus();
      }, 800);
    }
  }
  handleClickDateTextArea() {
    this.showEditable();
    setTimeout(() => {
      if (this.utilitiesService.isIOS()) {
        $(this.inputCheckIn.nativeElement).trigger('touchend');
      } else {
        $(this.inputCheckIn.nativeElement).trigger('click');
      }
    }, 400);
  }
  handleClickRoomTextArea() {
    this.showEditable();
    setTimeout(() => {
      if (this.inputRoomBox) {
        $(this.inputRoomBox.nativeElement).trigger('click');
      }
    }, 200);
  }
}




// WEBPACK FOOTER //
// ./src/app/components/promotion/promotion-search-box/promotion-search-box.component.ts